import { Instagram, Twitter, Youtube, Facebook, Globe } from "lucide-react";

const cols = [
  {
    title: "Shop",
    links: ["Men", "Women", "Kids", "Sale", "Gift Cards"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Press", "Sustainability", "Athletes"],
  },
  {
    title: "Support",
    links: ["Help Center", "Shipping", "Returns", "Sizing Guide", "Contact"],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0e0e10] text-white pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-[#ff5722] flex items-center justify-center">
                <span className="font-display font-bold text-lg leading-none">S</span>
              </div>
              <span className="font-display font-extrabold text-2xl tracking-tight">STRYDE</span>
            </div>
            <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-xs">
              Precision sneakers, engineered in Portland. Built to move — every step, every day.
            </p>

            <form className="mt-8 flex items-center gap-2 p-1.5 pl-4 rounded-full bg-white/5 border border-white/10 max-w-sm">
              <input
                type="email"
                placeholder="Sign up for updates"
                data-testid="footer-newsletter-input"
                className="flex-1 bg-transparent outline-none text-sm text-white placeholder-white/40 py-2 min-w-0"
                aria-label="Sign up for updates"
              />
              <button data-testid="footer-newsletter-submit" className="btn-accent !py-2 !px-4 text-sm">Join</button>
            </form>
          </div>

          <div className="md:col-span-6 grid grid-cols-3 gap-6">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="mono text-xs uppercase tracking-widest text-white/40 mb-4">{c.title}</div>
                <ul className="space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#" className="text-sm text-white/80 hover:text-[#ff5722] transition-colors link-sweep">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="md:col-span-2">
            <div className="mono text-xs uppercase tracking-widest text-white/40 mb-4">Follow</div>
            <div className="flex flex-wrap gap-2">
              {[Instagram, Twitter, Youtube, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  data-testid={`social-${i}`}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#ff5722] hover:border-[#ff5722] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>

            <div className="mt-8">
              <div className="mono text-xs uppercase tracking-widest text-white/40 mb-3">Region</div>
              <button className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors" data-testid="region-selector">
                <Globe size={14} /> US · English · USD
              </button>
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} STRYDE Athletics. All rights reserved.</div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
            <div className="flex items-center gap-2 ml-2">
              {["VISA", "MC", "AMEX", "PAY", "GPAY"].map((p) => (
                <span key={p} className="mono text-[9px] px-2 py-1 rounded bg-white/10 border border-white/10 tracking-wider">{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
